import React, { useState, useEffect, useRef } from "react";
import "./Setup.scss";
import {
  checkIfEngagementCodeExist,
  deleteEngagementTeamMember,
  getEngagement,
  saveTeamMember,
} from "../../store/services/engagement.service";
import { Input } from "../CommonUIComponents/Input/Input";
import { Select } from "../CommonUIComponents/Select/Select";
import { Table } from "../CommonUIComponents/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  createEngagement,
  setEngagementClientName,
  setEngagementCode,
  setEngagementName,
  setIsSaveAndNextDisabled,
  updateEngagement,
} from "../../store/slices/engagementSlice";
import {
  setupEngagementCodeRequired,
  AddUserBtn,
  setupTableHeaderEmailId,
  setupTableHeaderName,
  setupTableHeaderTeam,
  setupTeamSetup,
  setupSector,
  setupClientName,
  setupEngagementName,
  setupEngagementCode,
  setupHeader,
  setupEngagementCodeLength,
  sectorTooltip,
  SaveBtn,
  engagementCodeRegExp,
  engagementClientNameRegExp,
  engagementNameRegExp,
  maxLength20,
  maxLength100,
  setupEngagementNameLength,
  setupEngagementNameRequired,
  setupClientNameRequired,
  setupClientNameLength,
  commonEngagementNameClientNameError,
  commonEngCodeError,
  wafErrorMessage,
} from "../../util/constants";
import {
  addTeamMember,
  deleteTeamMember,
  getAllMasterSectors,
  getEngagementTeam,
  getSelectedMasterSectors,
  setSelectedSectors,
} from "../../store/slices/setupSlice";
import { AddUserIcon } from "../../icons/addUser";
import { AddUserModal } from "./SetupModal";
import CustomDeleteComponent from "./customDelete";
import { UserDeleteModal } from "./SetupDeleteModal";
import { Button } from "../CommonUIComponents/Button/Button";
import { getLockingData } from "../../store/slices/projectSlice";
import { LockerModal } from "../LockerModal/lockerModal";
import { SaveUserModuleLock } from "../../store/services/project.service";
import { Tooltip } from "../CommonUIComponents/Tooltip/Tooltip";
import { EmissionIcon } from "../../icons";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { setWafErrorFlag } from "../../store/slices/projectSlice";

export function Setup() {
  const engagement = useSelector((state) => state.engagement.engagement);
  const createEngagementLoading = useSelector(
    (state) => state.engagement.createEngagementLoading,
  );
  const selectedRegion = useSelector(
    (state) => state.engagement.selectedRegion,
  );
  const wafErrorFlag = useSelector((state) => state.project.wafErrorFlag);
  const [wafErrorMessageState, setWafErrorMessageState] = useState("");
  const allSectors = useSelector((state) => state.setup.allSectors);
  const selectedSectors = useSelector((state) => state.setup.selectedSectors);
  const teamList = useSelector((state) => state.setup.teamList);
  const teamListLoading = useSelector((state) => state.setup.teamListLoading);
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const [showAdduserModal, setOpenUserModal] = useState(false);
  const [showDeleteModal, setDeleteModel] = useState(false);
  const [teamMembertobeDeleted, setTeammembertobeDeleted] = useState("");
  const [engCodeErrorMessage, setEngCodeErrorMessage] = useState("");
  const [engNameErrorMessage, setEngNameErrorMessage] = useState("");
  const [clientNameErrorMessage, setClientNameErrorMessage] = useState("");

  const [lockedData, setLock] = useState();
  const [lockedBy, setLockedby] = useState();
  const [isLockerModalOpen, setLockerModalOpen] = useState(false);
  const [disableSaveEngagement, setSaveEngagement] = useState(true);
  const [engagementCode, saveEngagementCode] = useState("");
  const [engagementName, saveEngagementName] = useState("");
  const [clientName, saveEngagemnetClientName] = useState("");
  const lastCheckedEngagementCode = useRef("");

  useEffect(() => {
    if (wafErrorFlag) {
      setWafErrorMessageState(wafErrorMessage);
    }
  }, [wafErrorFlag]);

  useEffect(() => {
    const errors = computeErrors({
      engagementCode,
      engagementName,
      clientName,
      selectedSectors,
    });
    dispatch(setIsSaveAndNextDisabled({ isDisabled: !isFormValid(errors) }));
  }, [engagementCode, engagementName, clientName, selectedSectors, dispatch]);

  const validateField = ({
    value,
    maxLength,
    regExp,
    requiredMsg,
    lengthMsg,
    commonError,
  }) => {
    if (value?.length >= maxLength) {
      return lengthMsg;
    }

    if (!value) {
      return requiredMsg;
    }

    if (!regExp.test(value) || value === "-") {
      return commonError;
    }

    return "";
  };

  const computeErrors = ({
    engagementCode,
    engagementName,
    clientName,
    selectedSectors,
  }) => {
    const codeError = validateField({
      value: engagementCode,
      maxLength: maxLength20,
      regExp: engagementCodeRegExp,
      requiredMsg: setupEngagementCodeRequired,
      lengthMsg: setupEngagementCodeLength,
      commonError: commonEngCodeError,
    });

    const nameError = validateField({
      value: engagementName,
      maxLength: maxLength100,
      regExp: engagementNameRegExp,
      requiredMsg: setupEngagementNameRequired,
      lengthMsg: setupEngagementNameLength,
      commonError: commonEngagementNameClientNameError,
    });

    const clientError = validateField({
      value: clientName,
      maxLength: maxLength100,
      regExp: engagementClientNameRegExp,
      requiredMsg: setupClientNameRequired,
      lengthMsg: setupClientNameLength,
      commonError: commonEngagementNameClientNameError,
    });

    const sectorsError =
      !Array.isArray(selectedSectors) || selectedSectors.length === 0
        ? "Please select at least one sector."
        : "";

    return { codeError, nameError, clientError, sectorsError };
  };

  const isFormValid = (errors) =>
    !errors.codeError &&
    !errors.nameError &&
    !errors.clientError &&
    !errors.sectorsError;

  const handleInputChange1 = (event) => {
    dispatch(setWafErrorFlag(false));
    const value = event.target.value;
    const error = validateField({
      value,
      maxLength: maxLength20,
      regExp: engagementCodeRegExp,
      requiredMsg: setupEngagementCodeRequired,
      lengthMsg: setupEngagementCodeLength,
      commonError: commonEngCodeError,
    });

    setEngCodeErrorMessage(error);

    const valid =
      !error &&
      isFormValid({
        engagementCode: value,
        engagementName,
        clientName,
        error,
      });

    dispatch(setIsSaveAndNextDisabled({ isDisabled: !valid }));

    if (error === setupEngagementCodeLength) {
      return;
    }
    saveEngagementCode(value);
  };

  const handleInputChange2 = (event) => {
    dispatch(setWafErrorFlag(false));
    const value = event.target.value;
    const error = validateField({
      value,
      maxLength: maxLength100,
      regExp: engagementNameRegExp,
      requiredMsg: setupEngagementNameRequired,
      lengthMsg: setupEngagementNameLength,
      commonError: commonEngagementNameClientNameError,
    });

    setEngNameErrorMessage(error);

    const valid =
      !error &&
      isFormValid({
        engagementCode,
        engagementName: value,
        clientName,
        error,
      });

    dispatch(setIsSaveAndNextDisabled({ isDisabled: !valid }));
    if (error === setupEngagementNameLength) {
      return;
    }
    saveEngagementName(value);
  };

  const handleInputChange3 = (event) => {
    dispatch(setWafErrorFlag(false));
    const value = event.target.value;
    const error = validateField({
      value,
      maxLength: maxLength100,
      regExp: engagementClientNameRegExp,
      requiredMsg: setupClientNameRequired,
      lengthMsg: setupClientNameLength,
      commonError: commonEngagementNameClientNameError,
    });

    setClientNameErrorMessage(error);

    const valid =
      !error &&
      isFormValid({
        engagementCode,
        engagementName,
        clientName: value,
        error,
      });

    dispatch(setIsSaveAndNextDisabled({ isDisabled: !valid }));

    if (error === setupClientNameLength) {
      return;
    }
    saveEngagemnetClientName(value);
  };

  const hanleInputChange4 = async (event) => {
    if (Array.isArray(event)) {
      dispatch(setSelectedSectors({ selectedOptions: event }));
    }
    if (
      engagementCode &&
      !engCodeErrorMessage &&
      engagementName &&
      clientName &&
      event.length !== 0
    ) {
      dispatch(setIsSaveAndNextDisabled({ isDisabled: false }));
    } else {
      dispatch(setIsSaveAndNextDisabled({ isDisabled: true }));
    }
  };

  useEffect(() => {
    if (
      engagementCode &&
      !engCodeErrorMessage &&
      !engNameErrorMessage &&
      !clientNameErrorMessage &&
      engagementName &&
      clientName
    ) {
      setSaveEngagement(false);
    } else {
      setSaveEngagement(true);
    }
  }, [
    engagementCode,
    engagementName,
    clientName,
    engCodeErrorMessage,
    engNameErrorMessage,
    clientNameErrorMessage,
  ]);

  function openModal() {
    setOpenUserModal(true);
  }

  async function onDeleteUserClick(record) {
    setDeleteModel(true);
    setTeammembertobeDeleted(record.id);
  }

  const handleDeleteClose = () => {
    setDeleteModel(false);
    setTeammembertobeDeleted("");
  };

  async function handleDeleteConfirm() {
    const request = {
      engagementId: engagement.id,
      engagementTeamMemberId: teamMembertobeDeleted,
    };
    const data = await deleteEngagementTeamMember({ request });

    if (data.status === "Success") {
      dispatch(deleteTeamMember({ member: { id: teamMembertobeDeleted } }));
    }
    setDeleteModel(false);
  }

  async function handleAddUserModalClose() {
    setOpenUserModal(false);
  }

  const handleAddUSerModalSave = async (data) => {
    setOpenUserModal(false);
    let request = {
      ...data,
      activeFlag: true,
      engagementID: engagement.id,
    };
    const save = await saveTeamMember({ request });
    if (save.statusCode === 200) {
      dispatch(addTeamMember({ member: save.data }));
    }
    request = {
      emailId: data.email,
    };
  };

  const handlecheckIfEngagementCodeExist = async (event) => {
    const currentCode = event.target.value;
    if (currentCode && engagementCodeRegExp.test(currentCode)) {
      if (!currentCode || lastCheckedEngagementCode.current === currentCode)
        return;
      lastCheckedEngagementCode.current = currentCode;
      const data = await checkIfEngagementCodeExist({
        request: { engCode: currentCode },
      });
      if (data.code === 0) {
        if (engagement?.id) {
          const request = {
            id: engagement.id,
          };
          const code = await getEngagement({ request });
          if (code.data.engagementCode !== currentCode) {
            setEngCodeErrorMessage(data.status);
            dispatch(setIsSaveAndNextDisabled({ isDisabled: true }));
          }
        } else {
          setEngCodeErrorMessage(data.status);
          dispatch(setIsSaveAndNextDisabled({ isDisabled: true }));
        }
      } else {
        engCodeErrorMessage === ""
          ? setEngCodeErrorMessage("")
          : setEngCodeErrorMessage(engCodeErrorMessage);
      }
    }
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (allSectors.length === 0) {
      dispatch(getAllMasterSectors());
    }
  }, []);

  useEffect(() => {
    if (engagement?.id) {
      saveEngagementCode(engagement.engagementCode);
      saveEngagementName(engagement.engagementName);
      saveEngagemnetClientName(engagement.clientName);
      const request = {
        id: engagement.id,
      };

      if (allSectors.length !== 0 && !selectedSectors) {
        dispatch(
          getSelectedMasterSectors({
            masterSectors: allSectors,
            request: request,
          }),
        );
      }

      if (selectedSectors && selectedSectors.length !== 0) {
        dispatch(setIsSaveAndNextDisabled({ isDisabled: false }));
      }
    }
  }, [engagement?.id, dispatch, selectedSectors, allSectors]);

  useEffect(() => {
    if (engagement?.id) {
      dispatch(getEngagementTeam({ id: engagement.id }));
    }
  }, [engagement?.id, dispatch]);
  /* eslint-enable react-hooks/exhaustive-deps */

  async function createNewEngagement() {
    dispatch(setWafErrorFlag(false));
    dispatch(setEngagementCode({ code: engagementCode }));
    dispatch(setEngagementName({ name: engagementName }));
    dispatch(setEngagementClientName({ clientName: clientName }));
    if (engagement?.id) {
      let newEngagement = engagement;
      const request = {
        ...newEngagement,
        engagementName: engagementName,
        clientName: clientName,
        updatedBy: user.username,
        updatedDate: new Date().toString(),
      };
      dispatch(updateEngagement(request)).then((data) => {
        if (data.payload.id) {
          setSaveEngagement(true);
        }
      });
    } else {
      const request = {
        engagementName: engagementName,
        engagementCode: engagementCode,
        clientName: clientName,
        createdBy: user.username,
        engagementSetupStepID: 0,
        userName: user.username,
        regionID: selectedRegion.id,
      };

      dispatch(createEngagement(request)).then((data) => {
        if (data.payload.id) {
          setSaveEngagement(true);
        }
      });
    }
  }

  // to get a locked user flags
  useEffect(() => {
    if (engagement?.id) {
      const request = {
        LockedBy: user.username,
        ModuleName: "Engagement",
        EngagementID: engagement.id,
      };

      dispatch(getLockingData(request))
        .then((action) => {
          if (action) {
            const lockedData = action.payload.data.lockStatus;
            const lockedBy = action.payload.data.lockedBy;
            setLock(lockedData);
            setLockedby(lockedBy);
            if (lockedData === 2) {
              setLockerModalOpen(true);
            }
            if (engagement?.id && lockedData === 0) {
              const request = {
                LockedBy: user.username,
                ModuleName: "Engagement",
                lockGuid: engagement.id,
                Id: 0,
              };
              SaveUserModuleLock(request);
            }
          } else {
            console.error("Failed to fetch locking data:", action.error);
          }
        })
        .catch((error) => {
          console.error("Error fetching locking data:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div className="setup">
      <div className="setup-body">
        <div className="setup-header">
          <span className="setup-header-main">{`${setupHeader}  |  Hosting location - ${selectedRegion?.name}`}</span>
        </div>
        <div className="setup-body-details">
          <div className="setup-body-row">
            <div className="setup-row-half">
              <span className="setup-body-engagement-title">
                {setupEngagementCode}
                <span className="required-star">*</span>
              </span>
              <Input
                type={"text"}
                value={engagementCode}
                onChange={handleInputChange1}
                errorMessage={engCodeErrorMessage}
                isError={engCodeErrorMessage}
                disableErrorPlaceholder={true}
                onBlur={handlecheckIfEngagementCodeExist}
                disabled={
                  engagement.id ||
                  (lockedData === 1 &&
                    lockedBy !== user.username &&
                    engagement.id)
                }
              />
            </div>
            <div className="setup-row-half">
              <span>
                {setupEngagementName}
                <span className="required-star">*</span>
              </span>
              <Input
                type={"text"}
                value={engagementName}
                onChange={handleInputChange2}
                errorMessage={engNameErrorMessage}
                isError={engNameErrorMessage}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user.username &&
                  engagement.id
                }
                className={"engagement-name-input"}
              />
            </div>
          </div>
          <div className="setup-body-row">
            <div className="setup-row-half">
              <span>
                {setupClientName}
                <span className="required-star">*</span>
              </span>
              <Input
                type={"text"}
                value={clientName}
                errorMessage={clientNameErrorMessage}
                isError={clientNameErrorMessage}
                onChange={handleInputChange3}
                disabled={
                  lockedData === 1 &&
                  lockedBy !== user.username &&
                  engagement.id
                }
                className={"engagement-name-input"}
              />
            </div>
            <div className="setup-row-half"></div>
          </div>
          {wafErrorFlag && (
            <div className="waf-error-message">{wafErrorMessageState}</div>
          )}
          <div className="setup-body-row">
            <div className="setup-row-half">
              <LoadingIndicatorEmbed show={createEngagementLoading}>
                <Button
                  variant="primary"
                  onClick={createNewEngagement}
                  disabled={disableSaveEngagement || wafErrorFlag}
                >
                  {SaveBtn}
                </Button>
              </LoadingIndicatorEmbed>
            </div>
          </div>
        </div>
        <div className="setup-body-people">
          <div className="setup-body-row">
            <div className="setup-row-half">
              <span>
                {setupSector}
                <span className="required-star">*&nbsp;</span>
                <Tooltip
                  trigger={<EmissionIcon />}
                  variant="ghost"
                  tooltipText={sectorTooltip}
                ></Tooltip>
              </span>
              <Select
                onChange={hanleInputChange4}
                value={selectedSectors}
                multiple={true}
                visibleOptions={3}
                options={allSectors}
                disabled={
                  !engagement.id ||
                  (lockedData === 1 &&
                    lockedBy !== user.username &&
                    engagement.id)
                }
              />
            </div>
          </div>
          <div className="setup-body-row">
            <div className="setup-row-half">
              <span className="setup-user">{setupTeamSetup}</span>
              <Button
                className="setup-user-button"
                onClick={openModal}
                variant="primary-alt"
                disabled={
                  !engagement?.id ||
                  !selectedSectors ||
                  (lockedData === 1 &&
                    lockedBy !== user.username &&
                    engagement.id)
                }
              >
                <AddUserIcon />
                {AddUserBtn}
              </Button>
            </div>
            <div className="setup-row-half"></div>
          </div>
          <div className="setup-body-people-table">
            <Table
              rowData={teamList
                .map((value) => {
                  return {
                    name: value.name,
                    email: value.email,
                    engagementTeamTypeID:
                      value.engagementTeamTypeID === 0
                        ? "Internal"
                        : "External",
                    activeFlag: value.activeFlag,
                    id: value.id,
                  };
                })
                .filter((element) => element.activeFlag === true)}
              colDefs={[
                {
                  field: "name",
                  headerComponentParams: {
                    enableSorting: true,
                    showFilter: false,
                  },
                  headerName: setupTableHeaderName,
                  headerTooltip: setupTableHeaderName,
                  suppressMovable: true,
                  sortable: true,
                  flex: 1,
                },
                {
                  field: "email",
                  filter: true,
                  headerComponentParams: {
                    enableSorting: false,
                    showFilter: true,
                  },
                  headerName: setupTableHeaderEmailId,
                  headerTooltip: setupTableHeaderEmailId,
                  suppressMovable: true,
                  flex: 1,
                },
                {
                  field: "engagementTeamTypeID",
                  filter: true,
                  headerComponentParams: {
                    enableSorting: false,
                    showFilter: true,
                  },
                  headerName: setupTableHeaderTeam,
                  headerTooltip: setupTableHeaderTeam,
                  suppressMovable: true,
                  flex: 1,
                },
                {
                  field: "action",
                  cellRenderer: CustomDeleteComponent,
                  suppressMovable: true,
                  cellRendererParams: () => {
                    return {
                      onDeleteUserClick: onDeleteUserClick,
                    };
                  },
                  headerName: "",
                  flex: 0.2,
                  minWidth: 30,
                },
              ]}
              draggable={false}
              pagination={false}
              loading={teamListLoading}
            />
          </div>
        </div>
      </div>
      <AddUserModal
        isModalVisible={showAdduserModal}
        onClose={handleAddUserModalClose}
        onConfirm={handleAddUSerModalSave}
        userData={teamList}
      />
      <UserDeleteModal
        isModalVisible={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
      />
      {lockedData === 2 && lockedBy === user.username && (
        <LockerModal
          isOpen={isLockerModalOpen}
          onClose={() => setLockerModalOpen(false)}
        />
      )}
    </div>
  );
}
